export const GET_ESSN_KEY = `/generate-essnkey`
export const REGISTER_SERIAL_NUMBER = '/register-serial-number'

export const REGISTER_SERIAL_NUMBER_QUERY_KEYS = {
	GET_ESSN_KEY: 'getEssnKey',
	REGISTER_SERIAL_NUMBER: 'registerSerialNumber'
}
